<div class="linkedin-feed">
    <script src="https://elfsightcdn.com/platform.js" async></script>
    <div class="elfsight-app-e121c692-a233-4091-9b80-ad2392f16306" data-elfsight-app-lazy></div>
</div>
